export enum StatusType {
  Expired = 'expired',
  ExpiredSell = 'expired_sell',
  ExpiredLease = 'expired_lease',
  Pending = 'pending',
  Limited = 'limited',
  Rejected = 'rejected',
  None = ''
}

export interface MessageStatusProps {
  isPending?: boolean | null;
  isExpired?: boolean | null;
  isLimited?: boolean | null;
  isRejected?: boolean | null;
  isExpiredManually?: boolean | null;
  isLeased?: boolean | null;
  rejectReason?: string | null;
  expiresAt?: string;
}
